(function () {
  var FLIP_CLASS = 'hotspot-price--flip';
  var EDGE_MARGIN = 8;

  function updateHotspot(el) {
    var container = el.offsetParent;
    if (!container) return;

    el.classList.remove(FLIP_CLASS);
    var containerRect = container.getBoundingClientRect();
    var rect = el.getBoundingClientRect();

    if (rect.right > containerRect.right - EDGE_MARGIN) {
      el.classList.add(FLIP_CLASS);
      var flippedRect = el.getBoundingClientRect();
      if (flippedRect.left < containerRect.left + EDGE_MARGIN) {
        var rightOverflow = rect.right - containerRect.right;
        var leftOverflow = containerRect.left - flippedRect.left;
        if (leftOverflow > rightOverflow) {
          el.classList.remove(FLIP_CLASS);
        }
      }
    }
  }

  function updateAll() {
    document.querySelectorAll('.hotspot-price').forEach(updateHotspot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAll);
  } else {
    updateAll();
  }

  window.addEventListener('load', updateAll);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(updateAll);
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateAll, 150);
  });

  document.addEventListener('shopify:section:load', updateAll);
})();
